import Vue from 'vue';

/**
 * This sets up a number of secret hotkeys that do development related stuff.
 */
function globalShortcuts() {
	window.addEventListener(
		'keydown',
		function (event) {
			event = event || window.event;
			var target = event.target || event.srcElement;

			if (event.defaultPrevented) return; // Do nothing if the event was already processed

			if (!/INPUT|TEXTAREA|SELECT|BUTTON/.test(target.nodeName)) {
				switch (event.key) {
					case 'k':
						if (event.metaKey) {
							console.clear();
						}
						break;
					default:
						return; // Quit when this doesn't handle the key event.
				}

				// Cancel the default action to avoid it being handled twice
				event.preventDefault();
			}
		},
		true
	);
}

function showDevElements() {
	window.addEventListener(
		'keydown',
		function (event) {
			event = event || window.event;
			var target = event.target || event.srcElement;
			if (event.defaultPrevented) {
				return; // Do nothing if the event was already processed
			}

			if (event.key === 'k' && event.metaKey) {
				console.clear();
			}

			if (!/INPUT|TEXTAREA|SELECT|BUTTON/.test(target.nodeName)) {
				switch (event.key) {
					case '@':
						toggleDevElements();
						break;
					// case 'k':
					// 	if (event.metaKey) {
					// 		console.clear();
					// 	}
					// 	break;
					case 'T':
						$('body').toggleClass('new-theme');
						break;
					case 'Down': // IE/Edge specific value
					case 'ArrowDown':
						// Do something for "down arrow" key press.
						break;
					case 'Up': // IE/Edge specific value
					case 'ArrowUp':
						// Do something for "up arrow" key press.
						break;
					case 'Left': // IE/Edge specific value
					case 'ArrowLeft':
						// Do something for "left arrow" key press.
						break;
					case 'Right': // IE/Edge specific value
					case 'ArrowRight':
						// Do something for "right arrow" key press.
						break;
					case 'Enter':
						// Do something for "enter" or "return" key press.
						break;
					case 'Esc': // IE/Edge specific value
					case 'Escape':
						// Do something for "esc" key press.
						break;
					default:
						return; // Quit when this doesn't handle the key event.
				}

				// Cancel the default action to avoid it being handled twice
				event.preventDefault();
			}
		},
		true
	);
}

/**
 * Toggles the class 'development' in the body class-list. This shows or hides elements only needed for development.
 */
function toggleDevElements() {
	document.body.classList.toggle('development');
}

const hotkeyPlugin = {
	install() {
		globalShortcuts();

		if (process.env.NODE_ENV !== 'production') {
			showDevElements();
		}
	}
};

Vue.use(hotkeyPlugin);
